export default function neuroArchiveFilter() {
    const root = document.querySelector("[data-neuro-archive]");
    if (!root) return;

    const buttons = [...root.querySelectorAll("[data-neuro-filter]")];
    const cards = [...root.querySelectorAll("[data-neuro-cat]")];

    if (!buttons.length || !cards.length) return;

    const setActive = (key) => {
        const normalizedKey = (key || "").toLowerCase();

        buttons.forEach((btn) => {
            const isActive = btn.dataset.neuroFilter === key;
            btn.setAttribute("aria-pressed", isActive ? "true" : "false");
            btn.classList.toggle("button__green", isActive);
            btn.classList.toggle("button__outline", !isActive);
        });

        cards.forEach((card) => {
            const cat = (card.dataset.neuroCat || "").toLowerCase();
            const showAll =
                normalizedKey === "all" || normalizedKey === "todos";
            card.style.display = showAll || cat === normalizedKey ? "" : "none";
        });
    };

    buttons.forEach((btn) => {
        btn.addEventListener("click", () => {
            setActive(btn.dataset.neuroFilter);
        });
    });

    const initialActive = buttons.find((btn) =>
        btn.classList.contains("button__green"),
    );
    if (initialActive) {
        setActive(initialActive.dataset.neuroFilter);
    }
}
